import type { Teach } from '@pocketprep/types'

type TStudentState = {
    organizations: Teach.Class.OrganizationJSON[]
}

export const getInitialStudentState = (): TStudentState => {
    return {
        organizations: [],
    }
}

const moduleState = getInitialStudentState()

export default moduleState
